import React from "react";
import { Box } from "@mui/material";

const BoxContainer = ({ color = "#f0f0f0", children, boxSx = {}, ...restProps }) => {
    return (
        <Box
            {...restProps}
            sx={{
                p: 1,
                textAlign: "center",
                backgroundColor: color,  // Ensure this is a valid color
                height: "100%",
                borderRadius: 2,
                ...boxSx  // Allow custom sx props to override
            }}
        >
            {children}
        </Box>
    );
};

export default BoxContainer;
